import type { Achievement } from "../achievement.types";
import { allMoves } from "../moveHistory";

export const straightAndNarrowAchievement: Achievement = {
  id: "straightAndNarrow",
  name: "Straight and Narrow",
  icon: "ray-start-arrow",
  description: "Won in the fewest possible moves, by any route.",
  isProgressive: true,
  // Fewest hops by any route: the moves made, backtracked ones included, are
  // no more than the gold path's hops (par). `<=` keeps reports whose gold
  // path came from the old least-distance algorithm fair; with a gold path
  // from the corrected engine it is equivalent to `==`.
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport?.optimalPath?.length) return false;
    const moves = allMoves(gameReport).length;
    return moves > 0 && moves <= gameReport.optimalPath.length - 1;
  },
};
